import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
export const DEFAULT_SEARCH_PLACEHOLDER = 'DEFAULT_SEARCH_PLACEHOLDER';
export const createPlaceholderSearchResult = (msg = {}) => {
    const uuid = msg.uuid ?? msg.frontend_uuid ?? safeRandomUUID();
    return {
        status: 'PENDING',
        parent_info: undefined,
        query_str: '',
        backend_uuid: DEFAULT_SEARCH_PLACEHOLDER,
        author_username: undefined,
        author_image: undefined,
        search_focus: 'internet',
        display_model: 'turbo',
        display_models: [],
        personalized: false,
        attachments: [],
        social_info: {
            like_count: 0,
            fork_count: 0,
            user_likes: false,
        },
        text: undefined,
        collection_info: undefined,
        image_completions: [],
        is_related_query_result: false,
        final: false,
        sources: {
            sources: ['web'],
        },
        should_index: false,
        updated_datetime: new Date().toISOString(),
        thread_access: 0,
        thread_url_slug: '',
        expiry_time: undefined,
        privacy_state: undefined,
        context_uuid: '',
        related_queries: [],
        media_items: [],
        widget_data: [],
        blocks: [],
        message_mode: 'MESSAGE_MODE_UNSPECIFIED',
        widget_intents: [],
        knowledge_cards: [],
        plan: undefined,
        summary: undefined,
        form: undefined,
        sources_list: [],
        related_query_items: [],
        answer_modes: [],
        structured_answer_block_usages: [],
        ...msg,
        frontend_context_uuid: msg.frontend_context_uuid ?? safeRandomUUID(),
        frontend_uuid: uuid,
        uuid,
        attachment_processing_progress: [],
    };
};
//# sourceMappingURL=createPlaceholderSearchResult.js.map